/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { permissionCheck } from '../../../../app/helper-functions/PermissionCheck';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { get_check_leave_approvals } from '../../api/checkLeaveApprovalsApi';
let holiday_add, holiday_log, holiday_view;
let leave_approval_add, leave_approval_log, leave_approval_view;
let user_create, user_edit, user_delete, user_activity_log, user_view
let exit_checklist_add, exit_checklist_view, exit_checklist_logs;
let employee_attendance_add, employee_attendance_log, employee_attendance_view;
let employee_asset_add, employee_asset_activity_log, employee_asset_view;
let employee_leave_policy_add, employee_leave_policy_activity_log, employee_leave_policy_view;
let employee_announcement_add, employee_announcement_edit, employee_announcement_log, employee_announcement_view, employee_announcement_delete;
export function AsideMenuMain() {
  const [isApplyLeave, setIsApplyLeave] = useState(false);
  const isSuperAdmin = localStorage.getItem('is_superadmin') === '1';
  const { data: checkLeaveApprovalsData } = useQuery(
    'get_check_leave_approvals',
    get_check_leave_approvals,
    {
      refetchOnWindowFocus: false,
    }
  );
  useEffect(() => {
    if (checkLeaveApprovalsData?.data?.is_applyleave === 1) {
      setIsApplyLeave(true);
    } else {
      setIsApplyLeave(false);
    }
  }, [checkLeaveApprovalsData]);
  const intl = useIntl()
  employee_announcement_add = permissionCheck('announcement-create');
  employee_announcement_edit = permissionCheck('announcement-update');
  employee_announcement_delete = permissionCheck('announcement-delete');
  employee_announcement_log = permissionCheck('announcement-activity-log');
  employee_asset_add = permissionCheck('employeeasset-create')
  employee_asset_view = permissionCheck('employeeasset-view')
  employee_asset_activity_log = permissionCheck('employeeasset-activity-log')
  leave_approval_add = permissionCheck('leave-approval-create')
  leave_approval_view = permissionCheck('leave-approval-view')
  leave_approval_log = permissionCheck('leave-approval-activity-log')
  holiday_add = permissionCheck('holiday-create')
  holiday_view = permissionCheck('holiday-view')
  holiday_log = permissionCheck('holiday-activity-log')
  exit_checklist_add = permissionCheck('employeeexit-create')
  exit_checklist_view = permissionCheck('employeeexit-view')
  exit_checklist_logs = permissionCheck('employeeexit-activity-log')
  user_create = permissionCheck('user-create');
  user_edit = permissionCheck('user-update');
  user_delete = permissionCheck('user-delete');
  user_activity_log = permissionCheck('user-activity-log');
  user_view = permissionCheck('user-view');
  employee_attendance_add = permissionCheck('employeeattendance-create');
  employee_attendance_view = permissionCheck('employeeattendance-view');
  employee_attendance_log = permissionCheck('employeeattendance-activity-log');
  employee_leave_policy_add = permissionCheck('leave-policy-create')
  employee_leave_policy_view = permissionCheck('leave-policy-view')
  employee_leave_policy_activity_log = permissionCheck('leave-policy-activity-log')
  return (
    <>      {/* HR */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Employees</span>
        </div>
      </div>
      {
        user_create && (
          <AsideMenuItem
            to='/hr/employee/add-employee/personal-details'
            title='Add Employee'
            fontIcon='bi-archive'
            icon='fa fa-user-plus'
          />
        )
      }
      {
        user_edit && (
          <AsideMenuItem to='/hr/employee/list-employees' title='Edit Employees' fontIcon='bi-pencil-square'
            icon='bi bi-pencil-square' />
        )
      }
      {
        holiday_add || holiday_log || holiday_view ? (
          <AsideMenuItemWithSub
            to='/hr/employee/holidays-management'
            title='Holidays Managment'
            fontIcon='bi-archive'
            icon='fa fa-calendar'
          >
            {
              holiday_add && (
                <AsideMenuItem to='/hr/employee/holidays-management/add-holiday' title='Add Holiday' hasBullet={true} />
              )
            }
            {
              holiday_view && (
                <AsideMenuItem to='/hr/employee/holidays-management/holidays-list' title='List of Holidays' hasBullet={true} />
              )
            }
            {
              holiday_log && (
                <AsideMenuItem to='/hr/employee/holidays-management/all-holidays-logs' title='Logs of All Holidays' hasBullet={true} />
              )
            }
          </AsideMenuItemWithSub>
        ) : null
      }
      <AsideMenuItemWithSub
        to='/hr/employee'
        title='Leave Management'
        fontIcon='bi-archive'
        icon='fa fa-list-check'
      >
        {
          employee_leave_policy_add || employee_leave_policy_activity_log || employee_leave_policy_view || isSuperAdmin ? (
            <AsideMenuItemWithSub
              to='/hr/employee/leave-policies'
              title='Leave Policies'
              fontIcon='bi-archive'
              icon='abstract-37'
            >

              {
                (employee_leave_policy_add || isSuperAdmin) && (
                  <AsideMenuItem to='/hr/employee/leave-policies/add-leave-policy' title='Add Leave Policy' hasBullet={true} />
                )
              }
              {
                (employee_asset_view || isSuperAdmin) && (
                  <AsideMenuItem to='/hr/employee/leave-policies/leave-policies-list' title='Leave Policy List' hasBullet={true} />
                )
              }
            </AsideMenuItemWithSub>
          ) : null}


        {
          leave_approval_add || leave_approval_log || leave_approval_view || isSuperAdmin ? (
            <AsideMenuItemWithSub
              to='/hr/employee/leaves/approvals'
              title='Approval Details'
              fontIcon='bi-archive'
              icon='abstract-41'
            >
              {
                (leave_approval_add || isSuperAdmin) && (
                  <AsideMenuItem to='/hr/employee/leaves/approvals/add-approval' title='Add Approval' hasBullet={true} />
                )
              }
              {
                (leave_approval_view || isSuperAdmin) && (
                  <AsideMenuItem to='/hr/employee/leaves/approvals/approval-list' title='List of Approvals' hasBullet={true} />
                )
              }
            </AsideMenuItemWithSub>
          ) : null
        }
        <AsideMenuItemWithSub
          to='/hr/employee/leave-management'
          title='Employee Leave'
          fontIcon='bi-archive'
          icon='fa fa-list-check'
        >
          {(!isSuperAdmin) && (
            <>
              <AsideMenuItem to='/hr/employee/leave-management/add-leave' title='Leave Summary' hasBullet={true} />
              <AsideMenuItem to='/hr/employee/leave-management/apply-leave' title='Add Leave' hasBullet={true} />
              <AsideMenuItem to='/hr/employee/leave-management/leaves-list' title='My Leaves' hasBullet={true} />
            </>
          )}
          {(isApplyLeave || isSuperAdmin) && (
            <>
              <AsideMenuItem to='/hr/employee/leave-management/pending-approvals' title='List of pending approvals' hasBullet={true} />
              <AsideMenuItem to='/hr/employee/leave-management/accepted-approvals' title='List of accepted approvals' hasBullet={true} />
              <AsideMenuItem to='/hr/employee/leave-management/rejected-approvals' title='List of rejected approvals' hasBullet={true} />
            </>
          )}
          <AsideMenuItem to='/hr/employee/leave-management/all-leave-logs' title='Logs of All Leaves' hasBullet={true} />

        </AsideMenuItemWithSub>

      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/hr/employee'
        title='Attendace Management'
        fontIcon='bi-archive'
        icon='fa fa-user-clock'
      >
        <AsideMenuItemWithSub
          to='/hr/employee/attendance-management'
          title='My Attendance'
          fontIcon='bi-archive'
          icon='fa fa-user-clock'
        >

          <AsideMenuItem to='/hr/employee/attendance-management/add-attendance' title='Add Attendance' hasBullet={true} />
          <AsideMenuItem to='/hr/employee/attendance-management/attendance-list' title='List of Attendance' hasBullet={true} />
        </AsideMenuItemWithSub>

        {
          employee_attendance_add || employee_attendance_log || employee_attendance_view || isSuperAdmin ? (
            <AsideMenuItemWithSub
              to='/hr/employee/attendance-management-employees'
              title='Employee Attendance'
              fontIcon='bi-archive'
              icon='fa fa-address-book'
            >
              {
                (employee_attendance_add || isSuperAdmin) && (
                  <AsideMenuItem to='/hr/employee/attendance-management-employees/add-employee-attendance' title='Add Employee Attendance' hasBullet={true} />
                )
              }
              {
                (employee_attendance_view || isSuperAdmin) && (
                  <AsideMenuItem to='/hr/employee/attendance-management-employees/attendance-employee-list' title='List of Employees Attendance' hasBullet={true} />
                )
              }
              {
                (employee_attendance_log || isSuperAdmin) && (
                  <AsideMenuItem to='/hr/employee/attendance-management-employees/attendance-employees-all-logs' title='Logs of All Employees Attendance' hasBullet={true} />
                )
              }
            </AsideMenuItemWithSub>
          ) : null
        }


      </AsideMenuItemWithSub>

      {/* End HR */}
      {employee_asset_add || employee_asset_view || employee_asset_activity_log ? (
        <AsideMenuItemWithSub
          to='/hr/employee/employee-assets'
          title='Employee Asset Management'
          fontIcon='bi-archive'
          icon='abstract-41'
        >
          {
            employee_asset_add && (
              <AsideMenuItem to='/hr/employee/employee-assets/add-employee-asset' title='Add Employee Asset' hasBullet={true} />
            )
          }
          {
            employee_asset_view && (
              <AsideMenuItem to='/hr/employee/employee-assets/employee-assets-list' title='List of Employee Assets' hasBullet={true} />
            )
          }
          {
            employee_asset_activity_log && (
              <AsideMenuItem to='/hr/employee/employee-assets/all-employee-assets-logs' title='Logs of All Employee Assets' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
      ) : null
      }
      {employee_announcement_add || employee_announcement_log ? (
        <AsideMenuItemWithSub
          to='/hr/employee/announcements'
          title='Announcements'
          fontIcon='bi-archive'
          icon='ki-duotone ki-message-text-2 fs-2'
        >
          {
            employee_announcement_add && (
              <AsideMenuItem to='/hr/employee/announcements/add-announcement' title='Add Announcement' hasBullet={true} />
            )
          }
          <AsideMenuItem to='/hr/employee/announcements/announcement-list' title='List of Announcement' hasBullet={true} />
          {
            employee_announcement_log && (
              <AsideMenuItem to='/hr/employee/announcements/all-announcement-logs' title='Logs of All Announcements' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
      ) : null}
      {exit_checklist_add || exit_checklist_logs || exit_checklist_view ? (
        <AsideMenuItemWithSub
          to='/hr/employee/employee-exit-details'
          title='Employee Exit Details'
          fontIcon='bi-archive'
          icon='fa fa-person-walking-arrow-right'
        >
          {
            exit_checklist_add && (
              <AsideMenuItem to='/hr/employee/employee-exit-details/add-employee-exit-detail' title='Add Employee Exit Detail' hasBullet={true} />
            )
          }
          {
            exit_checklist_view && (
              <AsideMenuItem to='/hr/employee/employee-exit-details/employee-exit-details-list' title='List of Employee Exit Details' hasBullet={true} />
            )
          }
          {
            exit_checklist_logs && (
              <AsideMenuItem to='/hr/employee/employee-exit-details/all-employee-exit-detail-logs' title='All Employee Exit Details Logs' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
      ) : null}
    </>
  )
}
